import React, { useEffect, useRef, useState } from 'react';
import './checkboxList.scss';

export default function CheckboxList({
  items,
  selectOptions,
  alreadyChecked = [],
  style = {},
  textStyle = {},
  listItemWidth = '',
  disabled = false,
}) {
  const [optionsChecked, setOptionsChecked] = useState(alreadyChecked);
  const isRendered = useRef(true);

  useEffect(() => {
    if (isRendered.current) {
      isRendered.current = false;
    } else {
      selectOptions(optionsChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsChecked, optionsChecked.length]);

  const handleChange = (event) => {
    const { value, checked } = event.target;

    if (checked === true) {
      setOptionsChecked((s) => {
        let options = [...s, value];
        return options;
      });
    } else {
      setOptionsChecked((s) => {
        return s.filter((i) => i !== value);
      });
    }
  };

  return (
    <div className='checkbox' style={style}>
      {items &&
        items.map((item, index) => (
          <label
            key={index}
            style={{
              width: listItemWidth,
              cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
            }}
          >
            <input
              type='checkbox'
              value={item.type}
              onChange={handleChange}
              defaultChecked={item?.selected}
              disabled={disabled}
            />
            <p style={textStyle}>
              <span></span>
              {item.text}
            </p>
          </label>
        ))}
    </div>
  );
}
